(function () {
  'use strict';
  if (window.KZClarityGenerations) return;
  window.KZClarityGenerations = true;
  const allowed = new Set(['kz_generation_started', 'kz_generation_result', 'kz_generation_error', 'kz_cart_added']);
  const queue = [];
  function consented() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function emit(name, kind) {
    if (!allowed.has(name) || !consented()) return;
    if (typeof window.clarity !== 'function') {
      if (queue.length < 30) queue.push([name, kind]);
      return;
    }
    try {
      window.clarity('event', name);
      window.clarity('set', name, 'yes');
      if (['single', 'pair', 'pet', 'panel'].includes(kind)) window.clarity('set', 'kz_generation_type', kind);
    } catch (_) {}
  }
  let retries = 0;
  const readiness = setInterval(function () {
    if (!consented()) queue.length = 0;
    if (typeof window.clarity === 'function' && consented()) {
      queue.splice(0).forEach(function (entry) { emit(entry[0], entry[1]); });
    }
    if (++retries >= 60) { clearInterval(readiness); queue.length = 0; }
  }, 1000);
  if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
  // Observe only known generation requests. Never read uploads, request bodies or token values.
  const nativeFetch = window.fetch;
  const endpoints = {
    '/admin/orders-ai/api/storefront/product-grok-single-preview': 'single',
    '/admin/orders-ai/api/storefront/product-grok-pair-preview': 'pair',
    '/admin/orders-ai/api/storefront/product-seedream-preview': 'single',
    '/api/storefront/pet-seedream-preview': 'pet'
  };
  window.fetch = function (input, init) {
    let kind = '', cart = false;
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      const method = String(init && init.method || input && input.method || 'GET').toUpperCase();
      if (method === 'POST' && url.origin === 'https://karykatura.online') {
        kind = endpoints[url.pathname] || '';
        if (/^\/admin\/orders-ai\/api\/visualization-public\/[^/]+\/generate$/.test(url.pathname)) kind = 'panel';
      }
      cart = method === 'POST' && url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname);
    } catch (_) {}
    const pending = nativeFetch.apply(this, arguments);
    if (kind) emit('kz_generation_started', kind);
    if (kind || cart) {
      pending.then(function (response) {
        if (!response.ok) { if (kind) emit('kz_generation_error', kind); return; }
        if (cart) emit('kz_cart_added');
      }, function () { if (kind) emit('kz_generation_error', kind); }).catch(function () {});
    }
    return pending;
  };
  const seen = new WeakMap();
  function result(img) {
    if (!(img instanceof HTMLImageElement) || !img.complete || !img.naturalWidth) return;
    let kind;
    if (img.id === 'kkPairGeneratedImage') kind = 'pair';
    else if (img.id === 'kkGeneratedImage') kind = document.getElementById('kkSelectPreview') ? 'pet' : 'single';
    else if (img.closest('#kvResults')) kind = 'panel';
    if (!kind || !img.getClientRects().length || !consented()) return;
    const src = img.currentSrc || img.src;
    if (!src || seen.get(img) === src) return;
    seen.set(img, src);
    emit('kz_generation_result', kind);
  }
  document.addEventListener('load', function (event) { result(event.target); }, true);
  function scan() {
    document.querySelectorAll('#kkPairGeneratedImage,#kkGeneratedImage,#kvResults img').forEach(result);
  }
  // Catches cached images and result containers made visible after image load.
  let scheduled = false;
  const observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; scan(); });
  });
  function start() {
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'class', 'style'] });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
